import React, { useEffect } from 'react'
import { Carousel } from 'pcln-carousel'
import { ActionCard } from '@pcln/cards'
import analytics from '@/shared-utils/analytics'
import { getRecentSearchDisplayProps, onCardClick } from './utils'
import type { RecentTripSearches } from './types'
import { fireRecentSearchLoadEvent } from './ga4'

export default function RecentSearchCarousel({
  pageName,
  items
}: {
  pageName: 'homepage' | 'landing'
  items: ReadonlyArray<RecentTripSearches>
}) {
  useEffect(() => {
    if (items.length > 0) {
      fireRecentSearchLoadEvent(items, pageName)
    }
  }, [items, pageName])
  return (
    <Carousel
      arrowsPositions="top"
      arrowsPosition="side"
      currentSlide={0}
      displayArrowsMobile={false}
      slideSpacing={1}
      onSlideChange={() => {
        // do  nothing
      }}
      visibleSlides={[2.5, 2.5, 3.5]}
      mobileVisibleSlides={[1.2, 2.5]}
    >
      {items.reduce<JSX.Element[]>((validItems, item, index) => {
        try {
          const { overline, heading, icon, actionText, relativeUrl } =
            getRecentSearchDisplayProps(item)
          return [
            ...validItems,
            <ActionCard
              key={overline || index}
              headingWidth={[
                '194px',
                '100px',
                'null',
                '190px',
                '200px',
                '250px'
              ]}
              icon={icon}
              heading={heading}
              actionText={actionText}
              overline={overline}
              onClick={() => {
                onCardClick(item, relativeUrl, pageName, item.productType)
              }}
              handleSubmitCTA={() => {
                onCardClick(item, relativeUrl, pageName, item.productType)
              }}
              className="full-width"
            />
          ]
        } catch (err) {
          analytics.logError({
            message: 'Error in getRecentSearchDisplayProps',
            errorMessage: err instanceof Error ? err.message : String(err),
            logObject: {
              error: JSON.stringify(err),
              item
            }
          })
          return validItems
        }
      }, [])}
    </Carousel>
  )
}
